<template>
  <w-dialog :dialog-show="state" @handleClose="handleClose">
    <div slot="content" class="online-content flex-column-center" @touchmove.prevent>
      <span class="iconfont iconx" @click="handleClose"/>
      <p class="title">设置在线简历</p>
      <img src="https://files.wondercv.com/online_cv/online-cv.png" alt="">
      <p class="description">大厂名企 HR 已入驻超级简历，让 HR 看到您的简历，求职更高效</p>
      <button @click="setOnlineCv" class="theme-button flex-center">立即打开</button>
    </div>
  </w-dialog>
</template>

<script>
	import WDialog from '@/components/global/w-dialog'

	export default {
		name: 'online-cv-dialog',
		props: {
			state: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WDialog
		},
		methods: {
			setOnlineCv () {
				this.$emit('setOnlineCv')
      },
      handleClose () {
				this.$emit('handleClose')
      }
    }
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .online-content {
    position: relative;
    padding: 42px 32px 32px;
    width: 90vw;
    background-color: $color-light;
    border-radius: 10px;
    .iconfont {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 20px;
      color: #9c9c9c;
      font-weight: 400;
    }
    .title {
      font-size: $font-size-large;
      color: $color-title;
      margin-bottom: 18px;
    }
    img {
      width: 154px;
      margin-bottom: 12px;
    }
    .description {
      color: $color-dark-gray;
      line-height: 20px;
      margin-bottom: 32px;
    }
    button {
      width: 100%;
      height: 38px;
      font-size: $font-size-medium-x;
      border-radius: 4px;
    }
  }
</style>
